<template>
  <div class="m-1">
    <van-uploader :disabled="btnSubmitDisabled" v-model="fileList" multiple :before-read="beforeRead"/>
    <p>
      <van-button :disabled="btnSubmitDisabled" type="primary" @click="upload">提交审核</van-button>
    </p>
  </div>
</template>

<script>
import { Uploader } from 'vant-green';
import { Button } from 'vant-green';
import { Dialog } from 'vant-green';
import { Toast } from 'vant-green';

import Compressor from 'compressorjs';

import * as invCheckFacade from "../../../api/invcheck-facade.js";

export default {
  components:{
     vanUploader:Uploader,
     vanButton:Button
  },
  data(){
    return {
      fileList: [],
      message:"",
      btnSubmitDisabled: false,
      sessionId: ""
    };

  },
  mounted() {

    this.initWebSocket()
  },

  destroyed(){
    this.websocketclose()
  },
  methods: {
    beforeRead(file) {
      return new Promise((resolve) => {
        // compressorjs 默认开启 checkOrientation 选项
        // 会将图片修正为正确方向
        new Compressor(file, {
          quality: 0.6,
          success: resolve,
          error(err) {
            console.log(err.message);
          },
        });
      });
    },

    afterRead  (file)  {
      file.status = "uploading"
      file.message = "上传中..."
      // 此时可以自行将文件上传至服务器
      console.log(file);

      // setTimeout(() => {
      //   file.status = 'failed';
      //   file.message = '上传失败';
      // }, 1000);

    },

    async upload(){
      if(this.fileList.length <1){
        Toast.fail("请拍照、选择照片并且提交审核");
        return;
      }
      this.btnSubmitDisabled = true;
      let orgId = this.$route.query.orgId
      let token = this.$route.query.token
      let fileList = this.fileList;      

      // 文件逐个上传
      for(let fileInfo of fileList){
      // fileList.forEach(function(fileInfo) {
        let file = fileInfo.file
        fileInfo.status= "uploading"
        fileInfo.message = "处理中..."

        if(file.size < 8388608){
          var data = new FormData();
          data.append("orgId", orgId);
          data.append("files", file, file.name);
          data.append("token", token)

          // 执行文件上传
          await invCheckFacade
            .uploadFile(data)
            .then(() => {
              console.log("文件上传成功")
              fileInfo.status= "done"
              fileInfo.message = "处理成功"
            })
            .catch(err => {
              fileInfo.status= "failed"
              fileInfo.message = "处理失败:" + err
              console.log("err", err);
            });
        }else{
          fileInfo.status= "failed"
          fileInfo.message = "文件太大"
        }
      }

      // 上传处理完成之后，清空list
      Dialog.alert({
        message: '图片处理完成，请在电脑端查看审核结果',
      }).then(() => {
        // on close
        this.btnSubmitDisabled = false;
        this.fileList = [];
        // 向发票审核页面发送上传完成的命令
        let wsCommandDto = {}
        wsCommandDto.sessionId = this.sessionId;
        wsCommandDto.commandId = "fileSubmited";
        wsCommandDto.message = "发票图片已经上传"
        this.websocketsend(JSON.stringify(wsCommandDto))

      });

      
    },


    //初始化weosocket 
    initWebSocket() { 
      const wsuri = process.env.VUE_APP_WEBSOCKET_ROOT_PATH + "/eids-invoice/ws/camera";//ws地址
      console.log("正在连接ws: " + wsuri)
      this.websock = new WebSocket(wsuri); 
      this.websock.onopen = this.websocketonopen;
      this.websock.onerror = this.websocketonerror;
      this.websock.onmessage = this.websocketonmessage; 
      this.websock.onclose = this.websocketclose;
    }, 

    websocketonopen() {
      console.log("WebSocket连接成功");
      // 成功后，告诉对方我已经连接成功
      let sessionId = this.$route.query.sessionId
      this.sessionId = sessionId;
      let wsCommandDto = {}
      wsCommandDto.sessionId = sessionId;
      wsCommandDto.commandId = "mobileConnected";
      wsCommandDto.message = "手机已经连接成功"
      this.websocketsend(JSON.stringify(wsCommandDto))
    },
    websocketonerror(e) { //错误
      console.log("WebSocket连接发生错误:" + e);
    },
    websocketonmessage(e) { //数据接收 
      console.log(e.data)
    }, 

    websocketsend(agentData) {//数据发送 
      this.websock.send(agentData); 
    }, 
    websocketclose(e) { //关闭 
        // 向发票审核页面发送退出的命令
        // let wsCommandDto = {}
        // wsCommandDto.sessionId = this.sessionId;
        // wsCommandDto.commandId = "mobileDisconnected";
        // wsCommandDto.message = "已退出"
        // this.websocketsend(JSON.stringify(wsCommandDto))

      console.log("connection closed (" + e + ")"); 
    },
  },
};

</script>